"use client";
import BuilderSlider from "@/components/builderslider";
import LogoBSvg from "@/components/svg/logob";
import { motion, useInView } from 'framer-motion';
import { useRef, useState } from 'react';
import {useTranslations} from 'next-intl';

export default function BuilderInfo() {
  const t = useTranslations('builderInfo');
  
    const [hasAnimated, setHasAnimated] = useState(false);
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
  
    if (isInView && !hasAnimated) {
      setHasAnimated(true);
    }
    return (
      <>
        <div className="absolute inset-0 md:top-[30%] top-[16%] w-full md:h-[32.33%] h-[16%] bg-[#F6F6F6] -z-50"></div>
        <section className="relative">
          <motion.div
            className="mt-[30px] flex xl:flex-row flex-col gap-[25px] relative z-10"
            ref={ref}
            initial={{ opacity: 0, x: 0 }}
            animate={hasAnimated ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1.5 }}
          >
            <div className="xl:max-w-[358px] xl:h-[600px] w-full h-[460px]">
              <BuilderSlider />
            </div>
  
            <article className="relative bg-[#005F70] rounded-[35px] xl:px-[45px] px-[20px] flex flex-col w-full xl:order-1 order-[-1] pb-[41px]">
              <header className="flex items-center justify-between xl:mt-[55px] mt-[25px]">
                <LogoBSvg />
                <div>
                  <p className="text-white text-[12px]">{t('Completion')}</p>
                  <p className="text-white md:text-[34px] text-[22px] font-bold">
                    2019 {t('year')}
                  </p>
                </div>
              </header>
  
              <h2 className="text-white xl:text-[26px] text-[16px] xl:mt-[36px] mt-[30px] font-bold">
                {t('tittle')}
              </h2>
  
              <div className="text-white text-[16px]">
                <p className="xl:mt-[36px] mt-[30px]">{t('builderDescr')}</p>
                <p className="mt-[26px]">{t('quality')}</p>
              </div>
            </article>
          </motion.div>
        </section>
      </>
    );
  }
  
